import React, { FC } from 'react'
import {
	BtnComponent,
	FormBlockComponent,
	FormNotificationComponent,
	Heading,
	i18n,
	IconComponent,
	Indent,
	UITypes,
} from 'LibNeo'
import 'Pages/orders_design/styles/orders.scss'
import { IconWrapper } from 'Pages/orders_design/components/desktop_orders/modals/styled'
import { BlockError } from 'Pages/orders_design'

interface ComponentProps {
	text: string
	close?: () => void
	icon: string
	title: string
	error?: BlockError
	isMobile: boolean
}

export const BlockRequestModal: FC<ComponentProps> = ({
	text,
	close,
	icon,
	title,
	error,
	isMobile,
}): JSX.Element => {
	return (
		<>
			<IconWrapper>
				<Heading type="h5">{i18n(title)}</Heading>
				{!isMobile && (
					<Indent left={14}>
						<IconComponent type={UITypes.GREY_LIGHT} name={icon} />
					</Indent>
				)}
			</IconWrapper>
			<Indent top={24}>
				<FormNotificationComponent
					message={text}
					type={UITypes.WARNING}
					title={error === BlockError.blocked_by_priority_channel && 'orders.reassign_partner'}
					hideIcon={isMobile}
				/>
			</Indent>
			<Indent top={24}>
				<BtnComponent title="labels.close" outline onClick={close} block={isMobile} />
			</Indent>
			<FormBlockComponent centered />
		</>
	)
}
